import { TMobileRouterPath } from "../hooks/router";
import { routes } from "../router/mobile/routes";

type IScreenTimeEvent = Partial<{
  [prop in Partial<TMobileRouterPath>]: string;
}>;

export const screenTimeEvent: IScreenTimeEvent = {
  [routes.healthOverview.path]: "Health Overview",
};
